import { Button, Card, Col, ColProps, List, Row, Skeleton } from 'antd';
import React, { useContext } from 'react';
import styled from 'styled-components';
import { CategoryIcon } from '../mainCategory/Icon';
import { Context } from '../MunicipalNoticeBoard';
import { useHistory, useLocation } from 'react-router-dom';
import Icon from '@ant-design/icons/lib/components/Icon';
import { ArrowRightOutlined } from '@ant-design/icons';
import { CatAvatar } from './CatAvatar';

const ContentDiv = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
`;

export const PVFolderList = () => {
    const { mainFolder, icons } = useContext(Context);

    const folders = mainFolder?.children.filter((mf) => mf.countDocuments);

    const colProps: ColProps = { xs: 24, lg: 12 };
    const history = useHistory();
    const location = useLocation();

    console.log('folderlist');

    return (
        <div className="public-view__folder-list">
            <Row gutter={[16, 16]}>
                {folders?.map((folder) => (
                    <Col {...colProps} key={folder._id}>
                        <Card
                            title={
                                <h2 title={'Kategorie: ' + folder.name}>
                                    <CatAvatar folder={folder}></CatAvatar> {folder.name}
                                </h2>
                            }
                            hoverable
                            size="small"
                            bordered={true}
                            onClick={() =>
                                history.push({
                                    pathname: 'folder',
                                    search: location.search,
                                    state: { categoryId: folder._id },
                                })
                            }
                            cover>
                            <ContentDiv>
                                <span>{`${folder.countDocuments} ${
                                    folder.countDocuments === 1 ? 'Aushang' : 'Aushänge'
                                } vorhanden`}</span>
                                <Button title={'Kategorie ' + folder.name + ' anzeigen'}>Anzeigen</Button>
                            </ContentDiv>
                        </Card>
                    </Col>
                ))}
            </Row>
        </div>
    );
};
